export default __webpack_public_path__ + "static/media/oldman.18e6621a.png";